import React, { useEffect, useState } from "react";
import Grocerylogo from "../images/almoune-logo-1613775290.jpg";
import productimage1 from "../images/product-img-1.jpg";
import productimage2 from "../images/product-img-2.jpg";
import productimage3 from "../images/product-img-3.jpg";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { categoryTree } from "../data/categoryTree";
import AccountModal from "./AccountModal";

const getCartCount = () => {
  try {
    const raw = window.localStorage.getItem("almoune_cart_cache");
    if (!raw) return 0;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed.items)
      ? parsed.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
      : 0;
  } catch { return 0; }
};

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [cartCount, setCartCount] = useState(getCartCount());
  const [openMobileCats, setOpenMobileCats] = useState([]);
  const [showAccount, setShowAccount] = useState(false);
  const { role, user } = useAuth();

  const toggleMobileCat = (name) => {
    if (openMobileCats.includes(name)) {
      setOpenMobileCats(openMobileCats.filter((n) => n !== name));
    } else {
      setOpenMobileCats([...openMobileCats, name]);
    }
  };

  useEffect(() => {
    const update = () => setCartCount(getCartCount());
    window.addEventListener("storage", update);
    window.addEventListener("cart-updated", update);
    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener("cart-updated", update);
    };
  }, []);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const accountLabel = "Mon compte";

  return (
    <div>
      <div className="border-bottom pb-5">
        <div className="gw-topbar py-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-12 d-flex" style={{ alignItems: "center" }}>
                <span style={{ color: "#ffffff", fontFamily: "Nunito, sans-serif", fontWeight: 700 }}>Epicerie libanaise en ligne - pain libanais, tahini, halawa, cafe Najjar</span>
              </div>
              <div className="col-lg-4 col-md-5 text-end d-none d-lg-block">
                <div
                  className="d-flex justify-content-end align-items-center"
                  style={{ gap: "18px" }}
                >
                  <span className="text-muted" style={{ whiteSpace: "nowrap", fontSize: "0.92rem" }}>
                    Tel : +33 9 81 39 14 33
                  </span>
                  <button
                    type="button"
                    onClick={() => setShowAccount(true)}
                    className="text-decoration-none text-dark d-inline-flex align-items-center"
                    style={{ gap: "6px", whiteSpace: "nowrap", fontSize: "0.92rem", background: "transparent", border: "none", cursor: "pointer" }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-user">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span>{accountLabel}</span>
                  </button>
                  <Link
                    to="/ShopCart"
                    className="text-decoration-none text-dark d-inline-flex align-items-center position-relative"
                    style={{ gap: "6px", whiteSpace: "nowrap" }}
                    aria-label="Voir le panier"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-bag">
                      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                      <line x1={3} y1={6} x2={21} y2={6} />
                      <path d="M16 10a4 4 0 0 1-8 0" />
                    </svg>
                    <span>Panier</span>
                    <span className="badge rounded-pill bg-success">{cartCount}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container displaydesign">
        <div className="row g-4">
          <div className="col-8 col-sm-4 col-lg-9 py-2 ">
            <input className="form-control " style={{ width: "100%" }} placeholder="Rechercher un produit..." />
          </div>
          <div className="col-4 col-sm-4 col-lg-3 py-2 d-flex" style={{ justifyContent: "center" }}>
            <div className="list-inline">
              <div className="list-inline-item">
                <button type="button" onClick={() => setShowAccount(true)} className="text-muted position-relative" aria-label={accountLabel} style={{ background: "transparent", border: "none", cursor: "pointer" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-user">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx={12} cy={7} r={4} />
                  </svg>
                </button>
              </div>
              <div className="list-inline-item">
                <Link to="/ShopWishList" className="text-muted position-relative">
                  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-heart">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                  </svg>
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">3</span>
                </Link>
              </div>
              <div className="list-inline-item">
                <Link to="/ShopCart" className="text-muted position-relative" aria-label="Voir le panier">
                  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-bag">
                    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
                    <line x1={3} y1={6} x2={21} y2={6} />
                    <path d="M16 10a4 4 0 0 1-8 0" />
                  </svg>
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">{cartCount}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-light sticky-top">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src={Grocerylogo} style={{ width: 180, marginBottom: 6, marginLeft: "-10px" }} alt="Almoune" />
          </Link>
          <input className="form-control responsivesearch " placeholder="Rechercher pain, zaatar, cafe..." style={{ width: "35%" }} />

          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#mobile_nav" aria-controls="mobile_nav" aria-expanded="false" aria-label="Toggle navigation">
            <div className={`containerr ${isOpen ? "change" : ""}`} onClick={handleClick}>
              <div className="bar1"></div>
              <div className="bar2"></div>
              <div className="bar3"></div>
            </div>
          </button>

          <div className="collapse navbar-collapse" id="mobile_nav">
            <ul className="navbar-nav mr-auto mt-2 mt-lg-0 float-md-right"></ul>
            <ul className="navbar-nav navbar-light">
              <li className="nav-item dmenu dropdown mega-dropdown">
                <Link className="nav-link dropdown-toggle" to="/Shop" aria-haspopup="true" aria-expanded="false">
                  Nos rayons
                </Link>
                <div className="dropdown-menu mega-menu" aria-label="Nos rayons">
                  <div className="mega-menu-cols">
                    {categoryTree.map((top) => (
                      <div className="mega-menu-col" key={top.slug}>
                        <Link className="mega-menu-title" to={`/Shop?category=${encodeURIComponent(top.name)}`}>
                          {top.name}
                        </Link>
                        <ul className="mega-menu-list">
                          {top.children.map((child) => (
                            <li key={child.slug} className="mb-2">
                              <Link className="fw-bold text-dark text-decoration-none" style={{ fontSize: '0.9rem' }} to={`/Shop?category=${encodeURIComponent(child.name)}`}>
                                {child.name}
                              </Link>
                              {child.leaves.filter(leaf => leaf !== child.name).length > 0 && (
                                <ul className="list-unstyled ms-2 mt-1 mb-0">
                                  {child.leaves.filter(leaf => leaf !== child.name).map(leaf => (
                                    <li key={leaf} className="mb-1">
                                      <Link to={`/Shop?category=${encodeURIComponent(leaf)}`} className="text-muted text-decoration-none" style={{ fontSize: '0.85rem' }}>
                                        {leaf}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                    <div className="mega-menu-col">
                      <Link className="mega-menu-title antigaspi-title" to="/AntiGaspi">
                        🌿 Anti-gaspi
                      </Link>
                      <ul className="mega-menu-list">
                        <li><Link to="/AntiGaspi">Produits à sauver</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <Link className="nav-link antigaspi-nav" to="/AntiGaspi">
                  🌿 Anti-gaspi
                </Link>
              </li>
              <li className="nav-item"><Link className="nav-link" to="/">Accueil</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/Shop">Boutique</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/AboutUs">A propos</Link></li>
              <li className="nav-item"><Link className="nav-link" to="/Contact">Contact</Link></li>
            </ul>
            <div className="mobile-categories">
              <button
                type="button"
                className="btn btn-link w-100 text-start text-decoration-none fw-bold mobile-cat-toggle"
                onClick={() => toggleMobileCat("__roota__")}
              >
                Nos rayons <i className={`fa fa-chevron-${openMobileCats.includes("__roota__") ? "up" : "down"}`} />
              </button>
              {openMobileCats.includes("__roota__") && (
                <div className="ms-3">
                  {categoryTree.map((top) => (
                    <div key={top.slug} className="mb-1">
                      <button
                        type="button"
                        className="btn btn-link w-100 text-start text-decoration-none mobile-cat-parent"
                        onClick={() => toggleMobileCat(top.slug)}
                      >
                        {top.name} <i className={`fa fa-chevron-${openMobileCats.includes(top.slug) ? "up" : "down"}`} />
                      </button>
                      {openMobileCats.includes(top.slug) && (
                        <ul className="nav flex-column ms-3">
                          {top.children.map((child) => (
                            <li className="nav-item mb-1" key={child.slug}>
                              <Link className="nav-link py-1 fw-bold" to={`/Shop?category=${encodeURIComponent(child.name)}`}>
                                {child.name}
                              </Link>
                              {child.leaves.filter(leaf => leaf !== child.name).length > 0 && (
                                <ul className="nav flex-column ms-3 border-start ps-2">
                                  {child.leaves.filter(leaf => leaf !== child.name).map(leaf => (
                                    <li className="nav-item" key={leaf}>
                                      <Link className="nav-link py-0 text-muted" style={{ fontSize: '0.85rem' }} to={`/Shop?category=${encodeURIComponent(leaf)}`}>
                                        {leaf}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                  <div className="mb-1">
                    <Link className="nav-link py-1 fw-bold text-success" to="/AntiGaspi">🌿 Anti-gaspi</Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      <div className="offcanvas offcanvas-end" tabIndex={-1} id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div className="offcanvas-header border-bottom">
          <div className="text-start">
            <h5 id="offcanvasRightLabel" className="mb-0 fs-4">Panier</h5>
            <small>{cartCount} produit(s) selectionne(s)</small>
          </div>
          <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" />
        </div>
        <div className="offcanvas-body">
          <ul className="list-group list-group-flush">
            <li className="list-group-item py-3 px-0">
              <div className="row align-items-center">
                <div className="col-2"><img src={productimage1} alt="Pain libanais" className="img-fluid" /></div>
                <div className="col-8"><h6 className="mb-0">Pain Libanais - 5 pieces</h6><small className="text-muted">1 x 1,15 EUR</small></div>
                <div className="col-2 text-end"><span className="fw-bold">1,15 EUR</span></div>
              </div>
            </li>
            <li className="list-group-item py-3 px-0">
              <div className="row align-items-center">
                <div className="col-2"><img src={productimage2} alt="Cafe Najjar" className="img-fluid" /></div>
                <div className="col-8"><h6 className="mb-0">Cafe Najjar Nature 220g</h6><small className="text-muted">1 x 4,99 EUR</small></div>
                <div className="col-2 text-end"><span className="fw-bold">4,99 EUR</span></div>
              </div>
            </li>
            <li className="list-group-item py-3 px-0 border-bottom">
              <div className="row align-items-center">
                <div className="col-2"><img src={productimage3} alt="Zaatar" className="img-fluid" /></div>
                <div className="col-8"><h6 className="mb-0">Zaatar Premium Naturel 500g</h6><small className="text-muted">1 x 10,95 EUR</small></div>
                <div className="col-2 text-end"><span className="fw-bold">10,95 EUR</span></div>
              </div>
            </li>
          </ul>
          <div className="d-grid mt-4">
            <button className="btn btn-primary btn-lg d-flex justify-content-between align-items-center" type="submit">
              Commander <span className="fw-bold">17,09 EUR</span>
            </button>
          </div>
        </div>
      </div>

      <AccountModal open={showAccount} onClose={() => setShowAccount(false)} />
    </div>
  );
};

export default Header;
